import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "Ma mère a cru que j'avais menti et que je les avais achetées. C'est le plus beau compliment de ma vie !",
    author: 'Léa',
    location: '26 ans, Lyon'
  }, {
    quote: "Le kit d'emballage change tout. Ça transforme une simple fraise en un bijou de luxe.",
    author: 'Camille',
    location: '31 ans, Montréal'
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-warm-white" data-id="element-178">
      <div className="max-w-6xl mx-auto" data-id="element-179">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-180">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white rounded-xl md:rounded-2xl shadow-lg p-5 md:p-8" data-id="element-181">
              <div className="flex gap-0.5 mb-3 md:mb-4" data-id="element-182">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 fill-rose-gold text-rose-gold" data-id="element-183" />)}
              </div>

              <p className="text-sm sm:text-base md:text-lg text-gray-700 font-lato mb-4 md:mb-6 italic leading-relaxed" data-id="element-184">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-gray-200 pt-3 md:pt-4" data-id="element-185">
                <p className="font-playfair font-bold text-burgundy text-sm md:text-base" data-id="element-186">
                  {testimonial.author}
                </p>
                <p className="text-xs md:text-sm text-gray-500 font-lato" data-id="element-187">
                  {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}